import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useAccountData } from '../StorefrontThemeWrapper';
import { ExperienceHeader } from './components/ExperienceHeader';
import { BookingWidgetWrapper } from './components/BookingWidgetWrapper';
import { MobileBookingBar } from './components/MobileBookingBar';
import { ExperiencePageLayout } from './ExperiencePageLayout';
import { useLanguage } from '../../utils/GeneralUtils';
import { OrderPageData, OrderPageStatus } from '../../api';
import { RelatedExperiencesSection } from './components/RelatedExperiencesSection';

export const ExperiencePage = () => {
  const { orderPageId } = useParams();
  const [searchParams] = useSearchParams();
  const account = useAccountData();
  const language = useLanguage();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [orderPageId]);

  const orderPage = account?.experiences?.[0]?.order_pages?.find((op) => op.id === orderPageId);

  if (!account || !orderPage) {
    return null;
  }

  const experienceName = orderPage.label?.[language] || '';
  const isTrial = searchParams.has('trial');
  const allOrderPages = account.experiences?.[0]?.order_pages || [];
  const relatedOrderPages = (orderPage.related_order_page_ids || [])
    .map((id) => allOrderPages.find((candidate) => candidate.id === id))
    .filter((candidate): candidate is OrderPageData => !!candidate && candidate.status !== OrderPageStatus.ARCHIVED);

  return (
    <ExperiencePageLayout
      key={orderPageId}
      passOrOrderPage={orderPage}
      header={
        <ExperienceHeader
          name={experienceName}
          locationId={orderPage.location_id}
          durationMinutes={orderPage.duration}
          orderPage={orderPage}
          account={account}
          isTrial={isTrial}
        />
      }
      renderBookingWidget={(storefrontStyling) => <BookingWidgetWrapper storefrontStyling={storefrontStyling} />}
      renderMobileBar={(scrollToWidget) => (
        <MobileBookingBar orderPage={orderPage} account={account} onBookNowClick={scrollToWidget} isTrial={isTrial} />
      )}
      renderRelated={() => <RelatedExperiencesSection orderPages={relatedOrderPages} />}
    />
  );
};
